// extracted by mini-css-extract-plugin
module.exports = {"container":"scroll-header_container___Zlfd","heading":"scroll-header_heading__S9wLR","subheading":"scroll-header_subheading__j5X23","spot":"scroll-header_spot__y81lD"};